module.exports = __webpack_public_path__ + "static/media/icon_nav_on_support.f5e74f4b.svg";